// src/composables/useWechatShare.js
import { ref } from "vue";
import wx from "weixin-js-sdk";
import axios from "axios";

export default function useWechatShare() {
  const isSdkReady = ref(false);

  // 初始化SDK并注入自定义分享配置
  const setCustomShare = async (shareOptions) => {
    // 单页应用规则：必须传入去掉#哈希部分的当前URL，避免安卓端签名失效
    const currentUrl = window.location.href.split("#")[0];
    console.log('----currentUrl----', currentUrl);
    // 向后端请求合法签名参数
    const { data } = await axios.get("/weixin/js", {
      params: { url: currentUrl },
    });

    console.log('----data----', data);
    console.log('----shareOptions----', shareOptions);

    wx.config({
      debug: false,
      appId: data.appId,
      timestamp: data.timestamp,
      nonceStr: data.nonceStr,
      signature: data.signature,
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
    });

    wx.ready(() => {
      isSdkReady.value = true;
      // 配置分享给好友/QQ的内容
      wx.updateAppMessageShareData({
        title: shareOptions.title,
        desc: shareOptions.desc,
        link: shareOptions.link,
        imgUrl: shareOptions.imgUrl,
        success: () =>  console.log("好友分享配置生效1"),
      });
      // 配置分享到朋友圈/QQ空间的内容
      wx.updateTimelineShareData({
        title: shareOptions.title,
        link: shareOptions.link,
        imgUrl: shareOptions.imgUrl,
        success: () =>  console.log("朋友圈分享配置生效"),
      });
     
    });

    wx.error((err) => {
      console.error("分享配置失败", err);
      isSdkReady.value = false;
    });
  };

  return { setCustomShare, isSdkReady };
}
